import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PersonalizationsService } from '../base/services/personalizations/personalizations.service';
import { LoadingProComponent } from './components/loading-pro/loading-pro.component';
import { AvailableOperationTypes } from './models/operations/available-operation-types';
import { FinishProService } from './services/finish-pro.service';
import { LoadingProService } from './services/loading-pro.service';
import { Routes } from './models/routes';

@Component({
    selector: 'app-finish-pro',
    templateUrl: './finish-pro.component.html',
    styleUrls: ['./finish-pro.component.scss'],
})
export class FinishProComponent implements OnInit, OnDestroy, AfterViewInit {
    /**
     * Loading component from finish-pro.
     */
    @ViewChild('finishProLoading') finishProLoading: LoadingProComponent;

    routeSubscription: Subscription;

    loaderSubscription: Subscription;

    newOpLoaderSubscription: Subscription;

    constructor(
        private readonly finishProService: FinishProService,
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly personalizationService: PersonalizationsService,
        public loadingProService: LoadingProService) {
        this.personalizationService.hasFinishProActive = true;
    }

    ngAfterViewInit(): void {
        document.body.classList.add('is-finish');
    }

    async ngOnInit(): Promise<void> {
        try {
            await this.finishProService.getOperationDetail(true);
            const operationType = this.finishProService.operationDetailResponse?.operationType;

            if (operationType) {
                this.loadingProService.getOperationTypeProps(operationType as AvailableOperationTypes);
            }

            if (operationType === AvailableOperationTypes.STOP) {
                this.router.navigate(['/error']);
                return;
            }

            const route = this.finishProService.getRoutePath();

            if (route.includes(this.finishProService.FINISH_ROUTE)) {
                this.redirectToDefault();
                return;
            }

            if (route === Routes.LOGIN) {
                const operationId = this.finishProService.operationDetailResponse?.idOperation;
                const returnUrl = `/finishOperation/${operationId}`
                this.router.navigate(['/login'], {
                    queryParams: { returnUrl }
                })

                return;
            }

            await this.finishProService.getOperationDocumentsList(true);

            this.router.navigate([route], { relativeTo: this.route });
        } catch (e) {
            console.log(e);
        }
    }

    ngOnDestroy(): void {
        document.body.classList.remove('is-finish');
        this.personalizationService.hasFinishProActive = false;
        if (this.loaderSubscription) {
            this.loaderSubscription.unsubscribe();
        }
        if (this.newOpLoaderSubscription) {
            this.newOpLoaderSubscription.unsubscribe();
        }
    }

    redirectToDefault(): void {
        const replaceRoute = this.router.url.replace(
            this.finishProService.FINISH_PRO_ROUTE,
            this.finishProService.FINISH_ROUTE
        );
        this.router.navigateByUrl(replaceRoute);
    }
}
